import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center mt-8" }
const _hoisted_2 = { class: "flex items-center justify-center mb-4" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ps_label_header_4 = _resolveComponent("ps-label-header-4")!
  const _component_StripeElement = _resolveComponent("StripeElement")!
  const _component_ps_button = _resolveComponent("ps-button")!
  const _component_ps_modal = _resolveComponent("ps-modal")!
  const _component_ps_loading_dialog = _resolveComponent("ps-loading-dialog")!
  const _component_ps_error_dialog = _resolveComponent("ps-error-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ps_modal, {
      ref: "psmodal",
      isClickOut: false
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_ps_label_header_4, { class: "font-bold" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('stripe_credit_card_modal__card_entry')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      body: _withCtx(() => [
        _createVNode(_component_StripeElement, {
          element: _ctx.cardElement,
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.event = $event))
        }, null, 8, ["element"])
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ps_button, {
            class: "text-center w-60 mx-auto",
            onClick: _ctx.registerCard
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('stripe_credit_card_modal__save')), 1)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ps_button, {
            class: "text-center w-60 mx-auto ms-4",
            theme: "btn-second",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.actionClicked('no')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('stripe_credit_card_modal__cancel')), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.event && _ctx.event.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.event.error.message), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 512),
    _createVNode(_component_ps_loading_dialog, {
      ref: "psloading",
      isClickOut: false
    }, null, 512),
    _createVNode(_component_ps_error_dialog, { ref: "ps_error_dialog" }, null, 512)
  ], 64))
}